/** Rich relevance product inner element component */
/** @param {HTMLElement} element */
class RRProductInnerElement {
  constructor(element) {
    this.element = element;
  }

  /**
    * Gets the height of the product
    * @returns {int}
    */
  getHeight() {
    this.setHeight('auto');
    return this.element.offsetHeight;
  }

  /**
    * Sets the height of product
    * @param {int|string} height
    */
  setHeight(height) {
    this.element.style.height = height + (typeof height === 'string' ? '' : 'px');
  }
}

export default RRProductInnerElement;
